module.exports = __webpack_public_path__ + "img/order.70889cdf.png";